import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { Skeleton } from "antd";
import Header from "../../../component/menu/Header";
import SideMenu from "../../../component/menu/SideMenu";
import ReportDetailsComponent from "../../../component/restaurants/reports/details/ReportDetailsComponent";
import { ReportService } from "../../../services/reports-services";
import useUserStore from "../../../stores/store";
import CustomModal from "../../../component/modals/CustomModal";
import { orderDelete } from "../../../services/super-admin/general-service";

export default function OrderReportDetails() {
  const navigate = useNavigate();
  const { user, isSuperAdmin, setNetworkCall, showNotification } = useUserStore();
  const params = useParams();
  const { orderId } = params;
  const [orderReportDetail, setOrderReportDetail] = useState({});
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

  const onDeleteConfirm = async() => {
    setNetworkCall(true)
    const result = await orderDelete(orderId, user.token.token);
    showNotification(result.msg, !result.success);
    setNetworkCall(false);
    setIsOpenDeleteModal(false);

    if (result.success) {
      navigate('/sales/orders');
    }
  }

  const onClickDeleteOrder = () => {
    setIsOpenDeleteModal(true);
  }

  useEffect(() => {
    async function fetchOrderReportDetail() {
      const { data } = await ReportService.getOrderReportDetail(orderId, user.token.token);

      data.foods = data.foods.map((food) => {
        return {
          ...food,
          optionName: food.optionName === "System Default" ? "" : food.optionName,
        };
      });
      const payments = ReportService.getFormatedPaymentsData(data);

      console.log('=====payments=====', {payments});

      setOrderReportDetail({...data, payments});
    }

    fetchOrderReportDetail();
  }, []);

  return (
    <section>
      <div className="flex flex-col">
        <Header title={""} menu={""} currentMenuKey={user.isSuperAdmin ? "T_54_S_54_L_1" : "T_6_S_6"} />
        <div className="flex flex-row bg-prewhite px-[12%]">
          <SideMenu title={`Sale Report`} menu={""} />
        </div>
        <div className=" mt-[80px] ml-[80px] px-[50px]">
          <h1 className="pt-[50px] pb-[20px] font-bold text-black text-[24px] leading-[24px] cursor-default">
            Order Details
          </h1>

          {Object.keys(orderReportDetail).length === 0 ? (
            <Skeleton active={true} block={true} size={"large"} paragraph={{ rows: 7 }} shape={"square"} />
          ) : (
            <>
              <ReportDetailsComponent data={orderReportDetail} />
              {isSuperAdmin && 
              <div className="text-center">
                <button
                  key="Delete"
                  onClick={onClickDeleteOrder}
                  className="mb-5"
                  style={{
                    backgroundColor: "#FF4D4F",
                    color: "#FFFFFF",
                    fontFamily: "ubold",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                >
                  Delete
                </button>

              <CustomModal 
                isCustomModalOpen={isOpenDeleteModal}
                title="Are you sure to delete?"
                subTitle="If you delete this order it will not appear anywhere."
                onOk={onDeleteConfirm}
                onCancel={() => setIsOpenDeleteModal(false)}
                okText="Confirm"
                cancelText="No"
              >
                <br/>
              </CustomModal>
              </div>
              }
            </>
          )}
        </div>
      </div>
    </section>
  );
}
